import React, { useContext } from "react";
import { VegaCard, VegaFlex, VegaBox } from "@heartlandone/vega-react";
import ActivityCharge from "../ActivityInformations/Charge";
import ActivityState from "../ActivityInformations/State";
import ActivityPendingFeedbackState from "../ActivityInformations/PendingFeedbackState";
import ActivityScore from "../ActivityInformations/Score";
import ActivityTitle from "../ActivityInformations/Title";
import ActivityTimeRange from "../ActivityInformations/TimeRange";
import ActivityAddress from "../ActivityInformations/Address";
import ActivityCoverImage from "../ActivityInformations/CoverImage";
import ActivityActions from "../ActivityActions/Index";
import ActivityCategory from "../ActivityInformations/Category";
import { REGISERED_SUB_MENU } from "Chore/Constants";
import { HubContext } from "Redux/Context/context";

function RegisteredActivityListItem({ activity }) {
  const { myActivitiesState } = useContext(HubContext);
  const { subModule } = myActivitiesState;
  const {
    city,
    address,
    activityStatus,
    isOnlineActivity,
    chargeAmount = 0,
    endTime,
    startTime,
    title,
    coverUrl,
    publisherCategory,
    averageRating,
  } = activity;

  return (
    <VegaCard padding="size-24" variant="border">
      <VegaFlex justifyContent="space-between">
        <VegaFlex direction={"col"} gap={"size-12"}>
          <VegaFlex gap={"size-8"}>
            <ActivityState state={activityStatus} />
            {subModule === REGISERED_SUB_MENU.PENDING_FEEDBACK && (
              <ActivityPendingFeedbackState hasFeedback={activity.hasFeedback}/>
            )}
            <ActivityCategory category={publisherCategory} />
            <ActivityCharge chargeAmount={chargeAmount} />
            {subModule === REGISERED_SUB_MENU.CLOSED && (
              <ActivityScore score={averageRating} />
            )}
          </VegaFlex>
          <VegaFlex direction="col" gap="size-16">
            <ActivityTitle state={activityStatus} title={title} />
            <ActivityTimeRange startTime={startTime} endTime={endTime} />
            <ActivityAddress
              online={isOnlineActivity}
              city={city}
              address={address}
            />
          </VegaFlex>
        </VegaFlex>
        <ActivityCoverImage
          imageUrl={coverUrl || activity?.cover?.url}
          width="280px"
          height="138px"
          borderRadius="12px"
        />
      </VegaFlex>
      <VegaBox margin={{ top: "size-16" }}>
        <ActivityActions
          activity={activity}
        />
      </VegaBox>
    </VegaCard>
  );
}

export default RegisteredActivityListItem;
